import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-servicios_escolares',
  templateUrl: './servicios_escolares.component.html',
  styleUrls: ['./servicios_escolares.component.css']
})
export class Servicios_escolaresComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
